<template>
    <div class="baseBody baseBody-content">
        <ScaleBox>
            <div class="main-wraper relative">
				<div style="width: 50%;height:620px;position: absolute;left:25%;top:438px;">
					<BlockBox height="620" :hasTitle="false">
					    <template #content>
							<div style="padding-top: 5px;position: relative;">
								<div class="labelMenu">
									<div class="flex align-center">
										<div class="mapItem" @click="mapHandle(item.name,index)" :class="mpListIndex===index?'checked':''" v-for="(item,index) in mpList" :key="index"><el-image style="width: 54px; height: 34px"  :src="item.icon"  fit="cover"></el-image></div>
									</div>	
								</div>
								<div id="container"
									style="width: calc(100% - 10px);height:610px;margin: 0 auto;">
								</div>
							</div>
					    </template>
					</BlockBox>
					
				</div>

                <div class="custBodybg"></div>
                <div class="dateWeek">
                    <DynamicDate></DynamicDate>
                </div>
                <div class="fullBox">
                    <ScreenfullBox></ScreenfullBox>
                </div>
                <div class="baseTitleContent ">
                    <div class="baseTitleMid" style="width:759px;">
                        <div class="top" style="width:100%;">
                            <div class="topLine" style="width:100%;">
                                <div class="title text-center  text-white text-bold"  :style="'font-size:'+(siteName.length>11?30:32)+'px;'">{{siteName}}看板
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: fixed;width:100%;left:0;top:0;z-index:999;pointer-events:none;">
                    <div class="flex align-center justify-between">
                        <div>
                            <div class="baseTitleLeft"></div>
                        </div>
                        <div>
                            <div class="baseTitleRight"></div>
                        </div>
                    </div>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;left:0;z-index: 999;">
                    <LeftContent></LeftContent>
                </div>
                <div style="width:50% ;position: fixed;top: 60px;left:25%;z-index: 999;">
                    <MidContent ref="midBlock"></MidContent>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;right:0;z-index: 999;">
                    <RightContent></RightContent>
                </div>
            </div>
        </ScaleBox>
    </div>
</template>

<script>
    import AMapLoader from "@amap/amap-jsapi-loader";
    import DynamicDate from "../components/dynamicDate/index.vue";
    import ScreenfullBox from "../components/screenfull/index.vue";
    import ScaleBox from "../components/sacleBox/index.vue";
    import LeftContent from './components/fjzx/leftContent.vue'
    import RightContent from './components/fjzx/rightContent.vue'
    import MidContent from './components/fjzx/midContent.vue'
	import BlockBox from '@/views/components/blockBox'
    // import dataLineJson from './assets/data-line-in.json'
    import {
        fjCenterData,
         fjSiteDataTrack
    } from "@/api/api";
    export default {
        components: {
            LeftContent,
            RightContent,
            ScaleBox,
            DynamicDate,
            ScreenfullBox,
            MidContent,
			BlockBox
        },

        data() {
            return {
                map: null,
                lineList: [],
                postionList: [],
                runMakerList: [],
                dialogVisible: false,
                midData: null,
                siteId: '16',
                siteObj: {},
                // dataLineJson: require('@/assets/data-line-in.json'),
                loca: null,
                siteName:'',
                routeList:[],
				markerTcIdIndex:null,
				satelliteLayer:null,
				roadNetLayer:null,
				mpList:[
					{id:'mr',name:'mr',icon:require('@/assets/img/mr.png')},
					{id:'dark',name:'dark',icon:require('@/assets/img/dark.png')},
					{id:'wx',name:'wx',icon:require('@/assets/img/wx.png')}
				],
				mpListIndex:1,
				timer: null,
				 
            }
        },
        mounted() {
            this.siteId=this.$route.query.siteId || '16'
            this.siteName=this.$route.query.name || '分拣中心'
            this.changeData();
			this.timer = setInterval(() => {
			  this.changeData();
			}, 60000); // 60秒 = 60000毫秒
			if(this.mpListIndex==1){
				if(this.map){
					this.map.setMapStyle('amap://styles/darkblue');
				}
			}
        },
		beforeDestroy() {
		    // 组件销毁前清除定时器，避免内存泄漏
		    if (this.timer) {
		      clearInterval(this.timer);
		    }
		  },

        methods: {
			mapHandle(type,index){
				this.mpListIndex=index
				if(this.map){
					if(type=='wx'){
						 this.map.add(this.satelliteLayer);
					}else if(type=='dark'){
						this.map.remove(this.satelliteLayer);
						this.map.setMapStyle('amap://styles/darkblue');
					}
					else{
						 this.map.remove(this.satelliteLayer);
						 this.map.setMapStyle('amap://styles/normal');
					}
				}
				// this.map.setMapStyle('amap://styles/darkblue');
				
			},
            changeData() {
                let _self = this
                fjCenterData({
                    siteId: _self.siteId
                }).then(res => {
                    _self.$refs.midBlock.getData(res.data)
                    _self.siteObj = res.data.site
                    fjSiteDataTrack({siteId: _self.siteId}).then(e=>{
                        if(e.data.list && e.data.list.length>0){
                          _self.routeList=e.data.list
                        }
                    })
                    _self.$nextTick(function() {
                        _self.initAMap();
                    });
                });

            },
            handleClose() {
                this.dialogVisible = false
            },
            initAMap() {
                AMapLoader.load({
                    key: '18997a286e73c2d94837b10f89516387', // 高德地图API Key
                    version: '2.0', // 指定API版本
                    plugins: ["AMap.ControlBar", "AMap.ToolBar", "AMap.Scale", "Loca","AMap.MoveAnimation","AMap.TileLayer"], // 需要使用的插件
                    Loca: {
                        version: '2.0.0'
                    }, // 必须指定Loca版本
                    AMapUI: {
                        version: '1.1',
                        plugins: []
                    }
                }).then((AMap) => {
                    // let longitude = '105.985966';
                    // let latitude = '26.206922';
                    // 118.432765,31.361805

					// 构造官方卫星、路网图层
					   this.satelliteLayer = new AMap.TileLayer.Satellite()
					   // this.roadNetLayer =  new AMap.TileLayer.RoadNet()


                    this.map = new AMap.Map('container', {
                        zoom: 14,
                        zooms: [2, 20],
						// layers: [new AMap.TileLayer.Satellite()],
                        center: [this.siteObj.longitude, this.siteObj.latitude],
                    });
					this.map.setMapStyle('amap://styles/darkblue');
					this.satelliteLayer = new AMap.TileLayer.Satellite();
                    this.setPostion(AMap)
                    if(this.routeList && this.routeList.length>0){
                        this.routeList.forEach((item,index)=>{
                             this.showGjLine(this.map,AMap,item)
                             this.setMdPostion(AMap,item,index)
                        })
                    }
                }).catch(e => {
                    console.log(e);
                });
            },

            // 分拣中心点位
            setPostion(AMap) {
                let _self = this
                let title = '';
                if (_self.siteObj.siteName) {
                    title += "<br/>" + _self.siteObj.siteName;
                }
                title =
                    "<div class='fjzxName' style='background: url(https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507221140432025072211404304910884586.png) top center no-repeat;background-size:300px;height:51px;width:300px;height:51px;line-height:18px;font-size:20px;text-align:center;font-weight:bold'>" +
                    title + "</div>"
                let point = new AMap.Marker({
                    position: [_self.siteObj.longitude, _self.siteObj.latitude],
                    icon: new AMap.Icon({
                        // 图标尺寸
                        size: new AMap.Size(65, 75),
                        // 图标的取图地址
                        image: 'https://rs31zy.oss-cn-hangzhou.aliyuncs.com/2025/08/11/20250811144047A026.png',
                        // 图标所用图片大小
                        imageSize: new AMap.Size(65, 75),
                        
                    }),
                    zIndex:100,
                    offset: new AMap.Pixel(-32, -75), //设置偏移量
                    label: {
                        direction: 'top',
                        content: title,
                        offset: new AMap.Pixel(0, -5),
                    }
                });
                point.on("click", function() {
                    console.log(22222)
                    console.log(_self.dialogVisible, '33')
                    // _self.dialogVisible = true
                })
                // pointList.push(point);
                this.map.add(point);
            },
            // 门店点位展示
            setMdPostion(AMap,item,index) {
                console.log(item,'item1111')
                let _self = this
                let title = '';
                if (item.name) {
                    title = item.name;
                }
                // let logo='https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507301724582025073017245807460277365.jpg'
                if(!item.logo){
                    item.logo='https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507301724582025073017245807460277365.jpg'
                }
                title =
                    "<div class='mdBoxTip '  id='mdBoxId"+index+"'>" +
                    "<div class='flex align-center'><div class='mdlogo' style='background: url("+item.logo+") top center no-repeat;background-size:30px 30px;width:30px;height:30px; margin-right:5px'></div><div  style='text-align:left;font-size:12px'>"+title+"<div class='mdPhone'>电话："+(item.phone || "-")+"</div></div></div>"
                    "</div>"
                let point = new AMap.Marker({
                    position: [item.longitude*1,item.latitude*1],
                    icon: new AMap.Icon({
                        // 图标尺寸
                        size: new AMap.Size(40, 40),
                        // 图标的取图地址
						image:'https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202512231759522025122317595208400082730.png',
                        
                        // 图标所用图片大小
                        imageSize: new AMap.Size(40, 40),
                    }),
                    offset: new AMap.Pixel(-28, -43), //设置偏移量
                     zIndex:99,
                });

                point.on("click", function() {
					if(_self.markerTcIdIndex!==index){
						point.setLabel({
							direction: 'top',
							content: title,
							offset: new AMap.Pixel(0, -5),
						});
					}
					else{
						point.setLabel({
							direction: 'top',
							content: "",
							offset: new AMap.Pixel(0, -5),
						});
					}
					_self.markerTcIdIndex=index
                })
                // pointList.push(point);
                this.map.add(point);
            },

            showModal() {
                this.dialogVisible = true
            },
            //轨迹开始-
            showGjLine(map,AMap,item){
                let _self=this
                 var lineArr = [[item.longitude*1,item.latitude*1], [_self.siteObj.longitude, _self.siteObj.latitude]];
                 
                 var marker = new AMap.Marker({
                             map: map,
                             position: [item.longitude*1,item.latitude*1],
                             // icon: "https://rs31zy.oss-cn-hangzhou.aliyuncs.com/2025/08/08/20250808181343A002.png",
							  size: new AMap.Size(15, 29),
                             offset: new AMap.Pixel(-15, -29),
							 icon: new AMap.Icon({
							     // 图标尺寸
							     size: new AMap.Size(15, 29),
							     // 图标的取图地址
							     image: 'https://rs31zy.oss-cn-hangzhou.aliyuncs.com/2025/08/08/20250808181343A002.png',
							     // 图标所用图片大小
							     imageSize: new AMap.Size(15, 29),
							 }),
							
                         });
               
                   // 绘制轨迹
                         var polyline = new AMap.Polyline({
                             map: map,
                             path: lineArr,
                             showDir:true,
                             // strokeColor: "#fe8d00",  //线颜色
                             // strokeOpacity: 1,     //线透明度
                             strokeWeight: 0,      //线宽
                             strokeStyle: "solid"  //线样式
                         });
                         console.log(polyline)
                 
                         var passedPolyline = new AMap.Polyline({
                             map: map,
                             // strokeColor: "#AF5",  //线颜色
                             strokeWeight: 0,      //线宽
                         });
                 
                 
                         marker.on('moving', function (e) {
                             passedPolyline.setPath(e.passedPath);
                             // map.setCenter(e.target.getPosition(),true)
                         });
                     
                 
                         // map.setFitView();
                          marker.moveAlong(lineArr, {
                              // 每一段的时长
                              duration:15000+(Math.floor(Math.random() * 901) + 100),//可根据实际采集时间间隔设置
                              // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
                              autoRotation: true,
                            circlable:true,
                            aniInterval:500
                          });
                         
            }
           
            





        }
    }
</script>


<style lang="scss">
	
	.labelMenu{
		position: absolute;top: 20px;right:20px;z-index: 30;
		.mapItem{width: 60px;height:40px;margin-left: 10px;cursor: pointer;opacity:0.5;border:3px solid #ffffff;
		 &.checked{opacity:1;}
		 }
	}
	.hidden{display: none;}
    .fjzxName{color: #f2ff4a;}
    .mdBoxTip{border:1px solid rgba(69,233,255,1);box-shadow:  0 0 30px rgba(69,233,255,0.3) inset;background: rgba(5,83,101,0.4);border-radius: 7px;;width:180px;font-size:13px;text-align:center;font-weight:bold;padding:5px;color:#54ffe1;}
   .mdPhone{font-weight: normal;font-size: 10px;}
    .amap-marker-label {
        background: none !important;
        border: none;
    }
    .mdlogo{border-radius: 50%;}

    .pointer {
        cursor: pointer;
    }

    .custBoyModal {
        background: none;
        width: 384px;

        .modalContent {
            width: 384px;
            height: 244px;
            line-height: 1.5;
            padding: 50px 45px;
            box-sizing: border-box;
            margin: 0 auto;
            text-align: center;
            color: #FFFFFF;
            background: url('../assets/img/06.png') top left no-repeat;
            background-size: 100% 100%;
            text-align: left;
        }
    }

    .baseBody {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        font-size: 14px;
        background: #000208;
        position: relative;

        .main-wraper {
            user-select: none;
            width: 1920px;
            height: 1080px;
            margin: 0 auto;
            background: #02081a url('../assets/images/sytBg2.png') center no-repeat;
            background-size: cover;
            box-sizing: border-box;
        }

    }

    .dateWeek {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 200;
    }

    .fullBox {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 999;
    }

    .nyBaseHeadTop {
        width: 100%;
        height: 80px;
        background: url('../assets/images/titleBg.png') top center no-repeat;
        background-size: auto 80px
    }

    .base-headTit {
        font-size: 30px;
        font-weight: bold;
        box-sizing: border-box;
        padding-top: 24px;
    }

    .baseTitleLeft {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleLeft.png') top right no-repeat;
        background-size: auto 55px
    }

    .baseTitleRight {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleRight.png') top left no-repeat;
        background-size: auto 55px
    }

    .baseBody .baseTitleContent {
        width: 100%;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        z-index: 200;
    }

    .baseBody .baseTitleContent .baseTitleMid {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg3.png') top left no-repeat;
        background-size: 100% 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .top {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg2.png') top center no-repeat;
        background-size: 100% 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .topLine {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/titleBg4.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .title {
        width: 100%;
        height: 70px;
        margin: 0 auto;
        font-size: 34px;
        font-weight: bold;
        line-height: 70px;
        background: url('../assets/images/headtitileBg1.png') top center no-repeat;
		background-position: center;
		background-size: 100% auto;
        // background-size: auto 70px
    }

    .dataItem {
        width: 180px;
        height: 95px;
        line-height: 1;
        margin: 0 auto;
        text-align: center;
        color: #FFFFFF;
        background: url('../assets/img/04.png') top left no-repeat;
        background-size: 100% 100%;
        padding-top: 18px;
        box-sizing: border-box;

        .title {
            font-size: 18px;
            font-weight: bold;
        }

        .num {
            font-size: 41px;
            font-weight: bold;
            margin-top: 10px;
            color: #43eb93;

            &.yc {
                color: #ff8a00;
            }

            &.blue {
                color: #00d8ff;
            }

            &.purper {
                color: #c62bff;
            }

            &.red {
                color: #ff94a3;
            }

            s &.yellow {
                color: #fdc671;
            }
        }
    }

    .bgImg {
        width: 1920px;
        height: 1080px;
        line-height: 1;
        margin: 0 auto;
        text-align: center;
        color: #FFFFFF;
        background: url('../assets/img/bg.png') top left no-repeat;
        background-size: 100% 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 120;
        pointer-events: none;
    }

    .custBodybg {
        width: 1920px;
        height: 1080px;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        pointer-events: none;
        background: -webkit-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* Safari 5.1 - 6.0 */
        background: -o-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* Opera 11.6 - 12.0 */
        background: -moz-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* Firefox 3.6 - 15 */
        background: radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* 标准的语法 */
    }
    .mdBoxTip{
        
    }
</style>